import React from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useTotemBasic } from '../../../../hooks/useCases/useTotemBasic'
import { useFormNew } from '../../../../hooks/useFormNew'
import { Button, Grid } from '@material-ui/core'

export const FormBox = ({ box, closeModal }) => {
    const { insert, update } = useTotemBasic()
    const { formValues, handleInputChange } = useFormNew({
        ...(box?.id ? { id: box.id } : {}),
        descripcion: box?.descripcion || ""
    })
    const handleSubmit = () => box?.id ? update.box(formValues, closeModal) : insert.box(formValues, closeModal)
    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextValidator
                        name="descripcion"
                        value={formValues.descripcion}
                        onChange={handleInputChange}
                        label="Descripcion"
                        fullWidth
                        validators={["required"]} />
                </Grid>
                <Grid item xs={12} gap={2} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button color='secondary' onClick={closeModal}>CANCELAR</Button>
                    <Button color='primary' type='submit'>GUARDAR</Button>
                </Grid>

            </Grid>
        </ValidatorForm>
    )
}
